module.exports = __webpack_public_path__ + "img/34_14.da58ff08.png";